import { t } from '@lingui/macro';
import { FaSearchMinus } from 'react-icons/fa';

import { AccessibilityOption } from './AccessibilityButton';
import useAccesibilityActions from './hooks/useAccesibilityActions';

const DecreaseSizeFont = () => {
  const { changeSizeFontMinus } = useAccesibilityActions();
  return (
    <AccessibilityOption
      name={'Disminuir texto'}
      icon={<FaSearchMinus className="h-3 w-3 fill-white" />}
      onClick={() => changeSizeFontMinus()}
    />
  );
};

export default DecreaseSizeFont;
